<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div v-if="loaded" class="row">
        <div class="col-xl-3 col-lg-6">
          <stats-card id="stat-card-1"
                      title="Alcance Total"
                      type="gradient-red"
                      v-bind:sub-title="reachTotal7Days.toString()"
                      icon="ni ni-world-2"
                      class="mb-4 mb-xl-0"
          >

            <template slot="footer">
              <span v-if="reachDifference>0" class="text-success mr-2"><i
                  class="fa fa-arrow-up"></i>{{ reachDifference }}</span>
              <span v-if="reachDifference<0" class="text-danger mr-2"><i
                  class="fa fa-arrow-down"></i>{{ reachDifference }}</span>
              <span v-if="reachDifference==0" class="text-info mr-2">{{ reachDifference }}</span>
              <span class="text-nowrap">Desde os últimos 7 dias</span>
              <b-tooltip target="stat-card-1"
                         title="Número total de contas únicas que visualizaram este perfil nos últimos 7 dias"></b-tooltip>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card id="stat-card-2"
                      title="IMPRESSÕES TOTAIS"
                      type="gradient-orange"
                      v-bind:sub-title="impressionsTotal7Days.toString()"
                      icon="ni ni-chart-bar-32"
                      class="mb-4 mb-xl-0"
          >

            <template slot="footer">
              <span v-if="impressionsDifference>0" class="text-success mr-2"><i
                  class="fa fa-arrow-up"></i>{{ impressionsDifference }}</span>
              <span v-if="impressionsDifference<0" class="text-danger mr-2"><i
                  class="fa fa-arrow-down"></i>{{ impressionsDifference }}</span>
              <span v-if="impressionsDifference==0" class="text-info mr-2">{{ impressionsDifference }}</span>
              <span class="text-nowrap">Desde os últimos 7 dias</span>
              <b-tooltip target="stat-card-2"
                         title="Número total de vezes que os objetos de mídia da conta comercial foram visualizados nos últimos 7 dias"></b-tooltip>
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="TOTAL DE VISUALIZAÇÕES DO PERFIL"
                      id="stat-card-3"
                      type="gradient-green"
                      v-bind:sub-title="viewsTotal7Days.toString()"
                      icon="ni ni-glasses-2"
                      class="mb-4 mb-xl-0"
          >

            <template slot="footer">
              <span v-if="viewsDifference>0" class="text-success mr-2"><i
                  class="fa fa-arrow-up"></i>{{ viewsDifference }}</span>
              <span v-if="viewsDifference<0" class="text-danger mr-2"><i
                  class="fa fa-arrow-down"></i>{{ viewsDifference }}</span>
              <span v-if="viewsDifference==0" class="text-info mr-2">{{ viewsDifference }}</span>
              <span class="text-nowrap">Desde os últimos 7 dias</span>
              <b-tooltip target="stat-card-3"
                         title="Número total de usuários que visualizaram o perfil da conta comercial nos últimos 7 dias"></b-tooltip>
            </template>
          </stats-card>

        </div>
        <div class="col-xl-3 col-lg-6">
          <stats-card title="Novos seguidores"
                      id="stat-card-4"
                      type="gradient-info"
                      v-bind:sub-title="newFollowersTotal7Days.toString()"
                      icon="ni ni-single-02"
                      class="mb-4 mb-xl-0"
          >
            <template slot="footer">
              <span v-if="newFollowersDifference>0" class="text-success mr-2"><i
                  class="fa fa-arrow-up"></i>{{ newFollowersDifference }}</span>
              <span v-if="newFollowersDifference<0" class="text-danger mr-2"><i
                  class="fa fa-arrow-down"></i>{{ newFollowersDifference }}</span>
              <span v-if="newFollowersDifference==0" class="text-info mr-2">{{ newFollowersDifference }}</span>
              <span class="text-nowrap">Desde os últimos 7 dias</span>
              <base-button id="popover-reactive-1" type="info" size="sm" class="ml-4">
                TCS
                <b-popover
                    target="popover-reactive-1"
                    placement="auto"
                    ref="popover"
                >
                  <base-progress type="info" :height="8"
                                 :value="((totalNewFollowersLast30Days/(currentFollowers - totalNewFollowersLast30Days))*100).toFixed(2)"
                                 label="TAXA DE CRESCIMENTO DE SEGUIDORES"></base-progress>
                </b-popover>
              </base-button>
              <b-tooltip target="stat-card-4"
                         title="Número total de contas únicas seguindo este perfil nos últimos 7 dias"></b-tooltip>
            </template>
          </stats-card>
        </div>
      </div>
    </base-header>

    <!--Charts-->

    <div v-if="loaded" class="container-fluid mt--7">
      <div class="row" style="margin-bottom: 5px !important;">
        <div class="col-xl-12 mb-5 mb-xl-0">
          <card type="default" header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-light text-uppercase ls-1 mb-1">Performance</h6>
                <h5 class="h3 text-white mb-0">Análise de alcance</h5>
              </div>
              <div class="col">
                <ul class="nav nav-pills justify-content-end">
                  <li class="nav-item mr-2 mr-md-0">
                    <a class="nav-link py-2 px-3"
                       href="#"
                       :class="{active: bigLineChart.activeIndex === 0}"
                       @click.prevent="initBigChart(0)">
                      <span class="d-none d-md-block">7 Dias</span>
                      <span class="d-md-none">S</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link py-2 px-3"
                       href="#"
                       :class="{active: bigLineChart.activeIndex === 1}"
                       @click.prevent="initBigChart(1)">
                      <span class="d-none d-md-block">30 Dias</span>
                      <span class="d-md-none">M</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <line-chart
                v-if="loaded"
                :height="350"
                ref="bigChart"
                :chart-data="bigLineChart.chartData"
                :extra-options="bigLineChart.extraOptions"
            >
            </line-chart>

          </card>
        </div>
      </div>
      <div class="row">
        <div class="col-xl-6">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Demografia</h6>
                <h5 class="h3 mb-0">Distribuição por gênero (Desde os últimos 7 dias)</h5>
              </div>
            </div>

            <doughnut-chart
                v-if="loaded"
                :height="350"
                ref="pieChart"
                :chart-data="pieChart.chartData"
            >
            </doughnut-chart>
          </card>
        </div>
        <div class="col-xl-6">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Demografia</h6>
                <h5 class="h3 mb-0">Distribuição por idade (Desde os últimos 7 dias)</h5>
              </div>
            </div>

            <doughnut-chart
                v-if="loaded"
                :height="350"
                ref="pieChart"
                :chart-data="pieChartAge.chartData"
            >
            </doughnut-chart>
          </card>
        </div>
      </div>
      <!-- End charts-->

      <!--`GeoChart`-->
      <div class="row mt-5">
        <div class="col-xl-7 mb-5 mb-xl-0">
          <div class="card">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h6 class="text-uppercase text-muted ls-1 mb-1">Localização</h6>
                  <h3 class="mb-0">Seguidores Globais (Desde os últimos 7 dias)</h3>
                </div>
              </div>
            </div>

            <MapChart
                :countryData="GeoChart.chartData"
                highColor="#ff0000"
                lowColor="#aaaaaa"
                countryStrokeColor="#909090"
                defaultCountryFillColor="#dadada"
            />

          </div>

        </div>

        <div class="col-xl-5">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col">
                <h6 class="text-uppercase text-muted ls-1 mb-1">Localização</h6>
                <h5 class="h3 mb-0">Principais cidades/estados (Desde os últimos 7 dias)</h5>
              </div>
            </div>
            <bar-chart
                v-if="loaded"
                :height="350"
                ref="barChart"
                :chart-data="barChart.chartData"
                :extra-options="barChart.extraOptions"
            >
            </bar-chart>
          </card>
        </div>
      </div>
    </div>
    <div class="container-fluid mt--7" v-if="!loaded" style="margin-top: 45px !important;">
      <div class="row">
        <div class="col-xl-12">
          <div class="row align-items-center">
            <loading :active="!loaded"
                     :can-cancel="true"
                     :on-cancel="onCancel"
                     :is-full-page="fullPage"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Charts
import * as chartConfigs from '@/components/Charts/config';
import LineChart from '@/components/Charts/LineChart';
import DoughnutChart from '@/components/Charts/DoughnutChart';
import BarChart from '@/components/Charts/BarChart';
import axios from 'axios';
import BPopoverDirective from 'bootstrap-vue/es/directives/popover';
import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue'
import MapChart from 'vue-map-chart'
import Store from "@/store/store";
import Loading from 'vue-loading-overlay';

Vue.use(BootstrapVue)

export default {
  components: {
    MapChart,
    LineChart,
    DoughnutChart,
    BarChart,
    Loading
  },
  directives: {
    'v-b-popover': BPopoverDirective,
    'b-tooltip': BTooltipDirective,
  },
  data() {
    return {
      fullPage: true,
      GeoChart: {
        chartData: {},
        chartOptions: {
          chart: {
            title: 'Desempenho da Empresa',
            subtitle: 'Vendas, despesas e lucro: 2014-2024',
          }
        }
      },
      loaded: false,
      bigLineChart: {
        allReachData: [],
        allImpressionsData: [],
        allViewsData: [],
        allFollowersData: [],
        activeIndex: 0,
        chartData: {
          datasets: [],
          labels: [],
        },
        extraOptions: chartConfigs.lineChartOptionsBlue,
      },
      pieChart: {
        allData: [],
        allLabels: [],
        activeIndex: 0,
        chartData: {
          datasets: [],
          labels: [],
        }
      },
      pieChartAge: {
        allData: [],
        allLabels: [],
        activeIndex: 0,
        chartData: {
          datasets: [],
          labels: [],
        }
      },
      barChart: {
        chartData: {
          labels: [],
          datasets: [{
            data: []
          }],
        },
        extraOptions: {
          legend: {
            display: false,
          },
        },
      },
      facebookToken: Store.state.accessToken,
      instagramID: process.env.VUE_APP_FACEBOOK_INSTAGRAM_ID,
      clientSecret: process.env.VUE_APP_FACEBOOK_CLIENT_SECRET,
      appId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
      reachLast7Days: 0,
      impressionsLast7Days: 0,
      reachTotal7Days: 0,
      impressionsTotal7Days: 0,
      viewsTotal7Days: 0,
      newFollowersTotal7Days: 0,
      reachLast14Days: 0,
      impressionsLast14Days: 0,
      reachTotal14Days: 0,
      impressionsTotal14Days: 0,
      viewsTotal14Days: 0,
      newFollowersTotal14Days: 0,
      reachDifference: 0,
      impressionsDifference: 0,
      viewsDifference: 0,
      newFollowersDifference: 0,
      totalNewFollowersLast30Days: 0,
      currentFollowers: 0,
    };
  },
  created() {
  },
  methods: {
    onCancel() {
    },
    getToken(fbToken, client_secret, app_id) {
      const self = this
      axios.get(`https://graph.facebook.com/v19.0/oauth/access_token?grant_type=fb_exchange_token&client_id=${app_id}&client_secret=${client_secret}&fb_exchange_token=${fbToken}`)
          .then(response => {
            this.facebookToken = response.data.access_token

          }).catch(error => {
        if (error.toString().includes("403") || error.toString().includes("400")) {
          self.$store.commit('setUserName', "");
          self.$store.commit('setName', "");
          self.$store.commit('setAccessToken', "");
          self.$store.commit('setAuthentication', false);
          self.$router.push('/login');
        }
      })
    },
    async fetchData(instaID, fbToken) {
      let self = this

      let currentDate = new Date()
      let todayDaysAgo = new Date();
      let sevenDaysAgo = new Date();
      let fourteenDaysAgo = new Date();
      let thirtyDaysAgo = new Date();

      todayDaysAgo.setDate(currentDate.getDate());
      sevenDaysAgo.setDate(currentDate.getDate() - 7);
      fourteenDaysAgo.setDate(currentDate.getDate() - 14);
      thirtyDaysAgo.setDate(currentDate.getDate() - 30);

      let currentDateUnix = Math.floor(currentDate / 1000);
      let sevenDaysAgoUnix = Math.floor(sevenDaysAgo / 1000);
      let fourteenDaysAgoUnix = Math.floor(fourteenDaysAgo / 1000);
      let thirtyDaysAgoUnix = Math.floor(thirtyDaysAgo / 1000)

      const response1 = await axios.get(`https://graph.facebook.com/v19.0/${instaID}/insights?metric=impressions,reach,profile_views,follower_count&period=day&since=${sevenDaysAgoUnix}&until=${currentDateUnix}&access_token=${fbToken}`)
      let impressions = response1.data.data[0]
      let reach = response1.data.data[1]
      let profile_views = response1.data.data[2]
      let follower_count = response1.data.data[3]

      let reachLast7Days = []
      let impressionsLast7Days = []
      let viewsLast7Days = []
      let followersLast7Days = []

      for (let i = 0; i < impressions.values.length; i++) {
        self.impressionsTotal7Days += impressions.values[i].value
        impressionsLast7Days.push(impressions.values[i].value)
      }
      for (let i = 0; i < reach.values.length; i++) {
        self.reachTotal7Days += reach.values[i].value
        reachLast7Days.push(reach.values[i].value)
      }
      for (let i = 0; i < profile_views.values.length; i++) {
        self.viewsTotal7Days += profile_views.values[i].value
        viewsLast7Days.push(profile_views.values[i].value)

      }
      for (let i = 0; i < follower_count.values.length; i++) {
        self.newFollowersTotal7Days += follower_count.values[i].value
        followersLast7Days.push(follower_count.values[i].value)
      }

      self.bigLineChart.allReachData.push(reachLast7Days)
      self.bigLineChart.allImpressionsData.push(impressionsLast7Days)
      self.bigLineChart.allViewsData.push(viewsLast7Days)
      self.bigLineChart.allFollowersData.push(followersLast7Days)


      //Get the reach, impressions, profile views and new followers from last week and the week before last
      const response2 = await axios.get(`https://graph.facebook.com/v19.0/${instaID}/insights?metric=impressions,reach,profile_views,follower_count&period=day&since=${fourteenDaysAgoUnix}&until=${sevenDaysAgoUnix}&access_token=${fbToken}`)
      impressions = response2.data.data[0]
      reach = response2.data.data[1]
      profile_views = response2.data.data[2]
      follower_count = response2.data.data[3]

      let totalImpressions = 0;
      let totalReach = 0;
      let totalProfileViews = 0;
      let totalNewFollowers = 0;

      for (let i = 0; i < impressions.values.length; i++) {
        totalImpressions += impressions.values[i].value
      }
      for (let i = 0; i < reach.values.length; i++) {
        totalReach += reach.values[i].value
      }
      for (let i = 0; i < profile_views.values.length; i++) {
        totalProfileViews += profile_views.values[i].value
      }
      for (let i = 0; i < follower_count.values.length; i++) {
        totalNewFollowers += follower_count.values[i].value
      }

      self.impressionsDifference = self.impressionsTotal7Days - totalImpressions
      self.reachDifference = self.reachTotal7Days - totalReach
      self.viewsDifference = self.viewsTotal7Days - totalProfileViews
      self.newFollowersDifference = self.newFollowersTotal7Days - totalNewFollowers


      const response3 = await axios.get(`https://graph.facebook.com/v19.0/${instaID}/insights?metric=follower_demographics&period=lifetime&timeframe=this_week&breakdown=city&metric_type=total_value&access_token=${fbToken}`)
      let sample = response3.data.data[0].total_value.breakdowns[0].results

      let props = Object.keys(sample).map(function (key) {
        return {key: sample[key].dimension_values[0], value: sample[key].value};
      }, sample);

      props.sort(function (p1, p2) {
        return p2.value - p1.value;
      });
      let top5 = props.slice(0, 5);

      for (let i = 0; i < top5.length; i++) {
        self.barChart.chartData.labels.push(top5[i].key)
        self.barChart.chartData.datasets[0].data.push(top5[i].value)
      }


      //Get the reach, impressions, profile views and new followers from last 30 days
      const response4 = await axios.get(`https://graph.facebook.com/v19.0/${instaID}/insights?metric=impressions,reach,profile_views,follower_count&period=day&since=${thirtyDaysAgoUnix}&until=${currentDateUnix}&access_token=${fbToken}`)
      impressions = response4.data.data[0]
      reach = response4.data.data[1]
      profile_views = response4.data.data[2]
      follower_count = response4.data.data[3]

      let reachLast30Days = []
      let impressionsLast30Days = []
      let viewsLast30Days = []
      let followersLast30Days = []
      let totalNewFollowersLast30Days = 0

      for (let i = 0; i < impressions.values.length; i++) {
        impressionsLast30Days.push(impressions.values[i].value)
      }
      for (let i = 0; i < reach.values.length; i++) {
        reachLast30Days.push(reach.values[i].value)
      }
      for (let i = 0; i < profile_views.values.length; i++) {
        viewsLast30Days.push(profile_views.values[i].value)
      }
      for (let i = 0; i < follower_count.values.length; i++) {
        followersLast30Days.push(follower_count.values[i].value)
        totalNewFollowersLast30Days += follower_count.values[i].value
      }

      self.bigLineChart.allReachData.push(reachLast30Days)
      self.bigLineChart.allImpressionsData.push(impressionsLast30Days)
      self.bigLineChart.allViewsData.push(viewsLast30Days)
      self.bigLineChart.allFollowersData.push(followersLast30Days)
      self.totalNewFollowersLast30Days = totalNewFollowersLast30Days


      const response5 = await axios.get(`https://graph.facebook.com/v19.0/${instaID}/insights?metric=follower_demographics&period=lifetime&timeframe=this_week&breakdown=age&metric_type=total_value&access_token=${fbToken}`)

      sample = response5.data.data[0].total_value.breakdowns[0].results;
      let _13to17 = 0;
      let _18to24 = 0;
      let _25to34 = 0;
      let _35to44 = 0;
      let _45to54 = 0;
      let _55to64 = 0;
      let _65to74 = 0;

      for (let key in sample) {
        switch (sample[key].dimension_values[0]) {
          case "13-17":
            _13to17 += sample[key].value;
            break;

          case "18-24":
            _18to24 += sample[key].value;
            break;

          case "25-34":
            _25to34 += sample[key].value;
            break;

          case "35-44":
            _35to44 += sample[key].value;
            break;

          case "45-54":
            _45to54 += sample[key].value;
            break;

          case "55-64":
            _55to64 += sample[key].value;
            break;

          case "65+":
            _65to74 += sample[key].value;
            break;
        }

      }

      let age_data = [_13to17, _18to24, _25to34, _35to44, _45to54, _55to64, _65to74]

      let age_labels = ["13-17", "18-24", "25-34", "35-44", "45-54", "55-64", "65+"]

      let age_data_final = []
      let age_labels_final = []

      for (let i = 0; i < age_data.length; i++) {
        if (age_data[i] != 0) {
          age_data_final.push(age_data[i])
          age_labels_final.push(age_labels[i])
        }
      }
      self.pieChartAge.allData.push(age_data_final)
      self.pieChartAge.allLabels.push(age_labels_final)


      const response6 = await axios.get(`https://graph.facebook.com/v19.0/${instaID}/insights?metric=follower_demographics&period=lifetime&timeframe=this_week&breakdown=gender&metric_type=total_value&access_token=${fbToken}`)

      sample = response6.data.data[0].total_value.breakdowns[0].results;
      let male_sum = 0;
      let female_sum = 0;
      let undefined_sum = 0;

      for (let key in sample) {
        if (sample[key].dimension_values[0] == "F")
          female_sum += sample[key].value;
        else if (sample[key].dimension_values[0] == "M")
          male_sum += sample[key].value;
        else if (sample[key].dimension_values[0] == "U")
          undefined_sum += sample[key].value;
      }
      let gender_data = [male_sum, female_sum, undefined_sum]
      let gender_labels = ["Masculino", "Feminino", "Indefinido"]
      let gender_data_final = []
      let gender_labels_final = []

      for (let i = 0; i < gender_data.length; i++) {
        if (gender_data[i] != 0) {
          gender_data_final.push(gender_data[i])
          gender_labels_final.push(gender_labels[i])
        }
      }
      self.pieChart.allData.push(gender_data_final)
      self.pieChart.allLabels.push(gender_labels_final)


      const response7 = await axios.get(`https://graph.facebook.com/v19.0/${instaID}?fields=followers_count&access_token=${fbToken}`)

      self.currentFollowers = response7.data.followers_count;

      const response8 = await axios.get(`https://graph.facebook.com/v19.0/${instaID}/insights?metric=follower_demographics&period=lifetime&timeframe=this_week&breakdown=country&metric_type=total_value&access_token=${fbToken}`)
      sample = response8.data.data[0].total_value.breakdowns[0].results
      for (let key in sample) {
        const val = parseInt(sample[key].value)
        if (val > 0) {
          this.GeoChart.chartData[sample[key].dimension_values[0]] = val
        }
      }

    },
    initBigChart(index) {
      let x_labels = [];

      if (index == 0) {
        let days = ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'];
        let goBackDays = 7
        let today = new Date();

        for (let i = 0; i < goBackDays; i++) {
          let newDate = new Date(today.setDate(today.getDate() - 1));
          x_labels.unshift(days[newDate.getDay()]);
        }
      }

      if (index == 1) {
        let months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        let goBackDays = 30;
        let today = new Date();

        for (let i = 0; i < goBackDays; i++) {
          let newDate = new Date(today.setDate(today.getDate() - 1));
          x_labels.unshift(newDate.getDate().toString() + " " + months[newDate.getMonth()].toString());
        }

      }

      if (index == 2) {
        let months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
        let goBackMonths = 12;

        let today = new Date();

        for (let i = 0; i < goBackMonths; i++) {
          let newDate = new Date(today.setDate(today.getDate() - 31));
          x_labels.unshift(months[newDate.getMonth()]);
        }
      }

      let chartData = {
        datasets: [
          {
            label: 'Alcance',
            data: this.bigLineChart.allReachData[index],
            borderColor: '#e46646',
          },
          {
            label: 'Impressões',
            data: this.bigLineChart.allImpressionsData[index],
            borderColor: '#f1ac56'

          },
          {
            label: 'Visualizações',
            data: this.bigLineChart.allViewsData[index],
            borderColor: '#64cbc7'

          },
          {
            label: 'Novos Seguidores',
            data: this.bigLineChart.allFollowersData[index],
            borderColor: '#367ee8'

          },
        ],
        labels: x_labels,
      };
      this.bigLineChart.chartData = chartData;
      this.bigLineChart.activeIndex = index;
    },
    initPieChart(index) {

      let chartData = {
        datasets: [
          {
            label: 'Test',
            data: this.pieChart.allData[index],
            backgroundColor: [
              '#e46646',
              '#f1ac56',
              '#64cbc7',
              '#367ee8',
              '#8b64cb',
              '#cb647c',
              '#cacb64',
              '#84cb64',
              '#cb64b9'

            ]
          }
        ],
        labels: this.pieChart.allLabels[index]
      };
      this.pieChart.chartData = chartData;
      this.pieChart.activeIndex = index;

    },
    initPieChartAge(index) {

      let chartData = {
        datasets: [
          {
            label: 'Test',
            data: this.pieChartAge.allData[index],
            backgroundColor: [
              '#e46646',
              '#f1ac56',
              '#64cbc7',
              '#367ee8',
              '#8b64cb',
              '#cb647c',
              '#cacb64',
              '#84cb64',
              '#cb64b9'

            ]
          }
        ],
        labels: this.pieChartAge.allLabels[index]
      };
      this.pieChartAge.chartData = chartData;
      this.pieChartAge.activeIndex = index;

    }
  },
  async mounted() {
    this.loaded = false;
    await this.getToken(this.facebookToken, this.clientSecret, this.appId);
    await this.fetchData(this.instagramID, this.facebookToken);
    this.initBigChart(0);
    this.initPieChart(0);
    this.initPieChartAge(0);
    this.loaded = true;
  }
};
</script>
<style></style>
